// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"278":"65a8b501fba4484c","596":"1fd50b44c86ef434"}[chunkId] + ".js";
};